import React, { Component } from 'react';
import './App.css';
import './Home.css';
import SubscribeFrom from 'react-mailchimp-subscribe';
import Footer from './Footer'
import product from './images/heroProduct.svg';
import play from './images/play.svg';
import networking from './images/networking.svg';
import managing from './images/managing.svg';
import crowdsourcing from './images/crowdsourcing.svg';
import profiles from './images/1-network.png';
import calendar from './images/advancedCalendar.png';
import questions from './images/crowdSourcingAd.png';
import { Link } from 'react-router-dom'

const formProps = {
  action: 'https://zygouslabs.us17.list-manage.com/subscribe/post?u=7198e050a28cac79b536d0d07&amp;id=4cf907d94b',
  messages: {
    inputPlaceholder: "Enter email...",
    btnLabel: "Submit",
    sending: "Sending...",
    success: "Thanks! We'll keep you updated as we launch.",
    error: "Uh oh! An error occured."
  },
  styles: {
    sending: {
      fontSize: 18,
      color: "#8492A6"
    },
    success: {
      fontSize: 18,
      color: "#8EC9A9"
    },
    error: {
      fontSize: 18,
      color: "#EE6868"
    }
  }
}

class Home extends Component {
  
  render() {
    return (
      <div>
        <div id="hero">
            <div className="container">
              <h1>A virtual home for biomedical research</h1>
              <p>Zygous Labs is dedicated to promoting innovation through collaboration and developing creative technology solutions to unmet needs in the life science community</p>

              <div className="inputContainer">
              <SubscribeFrom {...formProps}/>

              </div>
            </div>
        </div>

        <div className="product">
          <div className="container">
            <div className="heroProductContainer">
              <img className="heroProduct" src={product} alt="Zygous Labs - Product"/>
              {/* <div className="watch">
                <img src={play} alt="Watch Video"/>
                <span>Watch</span>
              </div> */}
            </div>
          </div>
          <div className="stripe-1"></div>
          <div className="stripe-2"></div>
        </div>

        <div className="detailedInfo">
          <div className="container">
            <h2>Our platform is enabling scientists to streamline communication and accelerate research </h2>

            <div className="row">
              <div className="rowContainer">
                <div className="column">
                  <img src={networking}/>
                  <h3>Networking</h3>
                  <p>Create a personalized profile with keyworded research interests to build connections.</p>
                </div>
                <div className="column">
                  <div className="image negative-top">
                    <img className="profiles" src={profiles}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="rowContainer">
                <div className="column">
                  <img src={managing}/>
                  <h3>Managing</h3>
                  <p>Form collaborative groups with searchable conversations and shared calendars.</p>
                </div>
                <div className="column">
                  <div className="image positive-top">
                    <img className="advancedCalendar" src={calendar}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="rowContainer">
                <div className="column">
                  <img src={crowdsourcing}/>
                  <h3>Crowdsourcing</h3>
                  <p>Access relevant community knowledge through keyworded discussions.</p>
                </div>
                <div className="column">
                  <div className="image">
                    <img className="cS" src={questions}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="CTA">
                Want to learn more? <Link to='/contact'>Contact Us</Link>
              </div>
            </div>

          </div>
        </div>
      </div>

    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js